export default __webpack_public_path__ + "static/media/logo.91b2ca79.svg";